import {
	json,
	useLoaderData,
	type ClientLoaderFunctionArgs,
} from '@remix-run/react'
import UserProfile from '#app/components/userProfile/userProfile.tsx'
import { getSession } from '#app/utils/sessions.ts'
import { GeneralErrorBoundary } from '#app/components/common/errorBoundary'
import { getSigningContextForSigningUI } from '#app/utils/misc.server'

export const handle = {
	scripts: () => [{ src: 'https://www.instagram.com/embed.js', preload: true }],
}

export const loader = async ({
	context,
	request,
}: ClientLoaderFunctionArgs) => {
	const url = new URL(request.url)
	const params = url.searchParams.get('view')
	try {
		const signModalParams = await getSigningContextForSigningUI(request)
		const session = await getSession(request.headers.get('cookie'))
		const userId = session.get('userId')
		if (!userId || userId == 'loggedOut') {
			return json({
				userId: undefined,
				origin: url.origin,
				params,
				signModalParams,
				atomicLoreUrl: url.origin,
				atomicSignUrl: import.meta.env.VITE_ATOMICSIGN_URL,
			})
		}

		return json({
			userId,
			origin: url.origin,
			params,
			signModalParams,
			atomicLoreUrl: url.origin,
			atomicSignUrl: import.meta.env.VITE_ATOMICSIGN_URL,
		})
	} catch (e) {
		console.error(e)
		return {
			userId: undefined,
			origin: url.origin,
			params,
			signModalParams: undefined,
			atomicLoreUrl: url.origin,
			atomicSignUrl: import.meta.env.VITE_ATOMICSIGN_URL,
		}
	}
}

export default function userPage() {
	const {
		userId,
		origin,
		params,
		atomicLoreUrl,
		signModalParams,
		atomicSignUrl,
	} = useLoaderData<typeof loader>()

	return (
		<UserProfile
			userId={userId}
			signModalParams={signModalParams}
			origin={origin}
			params={params}
			atomicLoreUrl={atomicLoreUrl}
			atomicSignUrl={atomicSignUrl}
		/>
	)
	// }
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
